import React, { useContext, useEffect } from "react";
// import ManagementSidebar from "components/common/ManagementSidebar";
import Orders from "./MainOrder.jsx";
import UserContext from "../../../context/order/UserContext";
import AdminOrdersContext, {
  AdminOrdersProvider
} from "../../../context/order/AdminOrdersContext.tsx";
const OrdersSuperAdmin = () => {
  const { setSuperAdminOrders } = useContext(UserContext);
  useEffect(() => {
    setSuperAdminOrders(true);
  }, []);
  return (
    <div className="d-flex">
      {/* <ManagementSidebar></ManagementSidebar> */}
      <AdminOrdersProvider>
        <Orders />
      </AdminOrdersProvider>
    </div>
  );
};
export default OrdersSuperAdmin;
